import { WizTableForm } from '../../common'
const config = WizTableForm.Config.trainSite()

//配置项
let componentName = 'siteEquipment'

const columns = (self) => {
  let reg = new RegExp('^[0-9a-zA-Z_\-]{6,}$')
  let { record } = self.state
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '设备编号',
      name: 'code',
      searchItem: {},
      tableItem: {
        width: 200,
      },
      formItem: {
        maxLength: 50,
        placeholder: '设备编码最多输入50个字',
        rules: [
          {
            required: true,
            message: '请输入设备编号'
          },
          {
            pattern: reg,
            message: '设备编号仅支持6位以上字母、-、_及数字组合'
          }
        ]
      },
    },
    {
      title: '设备ID',
      name: 'deviceId',
      tableItem: {
        width: 200,
      },
      formItem: {
        maxLength: 50,
        placeholder: '设备ID最多输入50个字',
        rules: [
          {
            required: true,
            message: '请输入设备ID'
          },
          {
            pattern: reg,
            message: '设备ID仅支持6位以上字母、-、_及数字组合'
          }
        ]
      },
    },
    {
      title: '设备类型',
      name: 'type',
      dict: [
        { code: 0, codeName: '扫码器' },
        { code: 1, codeName: 'PAD' },
        { code: 2, codeName: '显示器' },
        { code: 3, codeName: '电脑主机' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {
        width: 100,
      },
      formItem: {
        type: 'select',
        rules: [{
          required: true,
          message: '请选择设备类型'
        }]
      }
    },
    {
      title: '设备型号',
      name: 'deviceModel',
      searchItem: {},
      tableItem: {
        width: 100,
      },
      formItem: {
        maxLength: 50,
        placeholder: '设备型号最多输入50个字',
        rules: [{
          required: true,
          message: '请输入设备型号'
        }]
      },
    },
    {
      title: '关联场地',
      name: 'siteId',
      formItem: {
        diy: WizTableForm,
        ...config,
        initRows: [{ id: record.siteId, name: record.siteName }],
        rules: [{
          required: true,
          message: '请选择关联场地'
        }]
      }
    },
    {
      title: '设备状态',
      name: 'status',
      dict: [
        { code: 0, codeName: '启用' },
        { code: 1, codeName: '停用' },
        { code: 2, codeName: '备用' },
        { code: 3, codeName: '维修' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {
        width: 100,
      },
      formItem: {
        type: 'radio',
        rules: [{
          required: true,
          message: '请选择设备状态'
        }]
      }
    },
    {
      title: '关联场地名称',
      name: 'siteName',
      tableItem: {
        width: 100
      }
    },
    {
      title: '关联场地名称',
      name: 'name',
      searchItem: {},
    },
    {
      title: '关联场地编号',
      name: 'siteCode',
      tableItem: {
        width: 100,
      }
    },
    {
      title: '添加时间',
      name: 'createTime',
      tableItem: {
        // width: 150,
      }
    },
    {
      title: '管理密钥',
      name: 'password',
      formItem: {
        type: 'input'
      }
    },
    {
      title: '备注',
      name: 'remark',
      formItem: {
        type: 'textarea',
        maxLength: 100,
        placeholder: '备注最多输入100个字'
      }
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(self),
        needMonitor: self._onChange,
        searchBarProps: {
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update'],
        rowOperateView: []
      }
    }
  }
}

const apis = (siteId = []) => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {siteId: siteId}
      }
    },
    add: {
      path: `${componentName}/create`,
      payload: {
        key: `${componentName}@create`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {siteId: siteId}
      }
    },
  }
}

let reduxTemplateCofig = (args) => {
  let {siteId} = args;
  return {
    apis: apis(siteId),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
